import userService from "@/services/user/userService";
import { showErrorAPI } from "@/services/apiRoutes";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { AxiosResponse } from "axios";

interface MFAServiceDependencies {
  getUiText: (id: string) => string;
  showToastError: (message: string) => void;
  routerPush: (path: string) => void;
  routerGoBack: () => void;
  sessionStorageSetItem: (key: string, value: string) => void;
  afterLoginActions: (data: any) => Promise<void>;
}

export const submitMFAVerification = async (
  verifyToken: string,
  disableButton: boolean,
  totpValid: boolean,
  deps: MFAServiceDependencies,
) => {
  if (disableButton || !totpValid) return;

  try {
    const res = (await userService.verifyMFAToken({
      token: verifyToken,
    })) as AxiosResponse;

    if (res?.status === 200 && res.data) {
      await deps.afterLoginActions(res.data.data);
    }
  } catch (error: any) {
    const errorData = error?.data;

    if (errorData?.error?.type) {
      const errorType = errorData.error.type;

      if (errorType === "exc_session_invalid-1") {
        deps.sessionStorageSetItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(errorData.error),
        );
        deps.routerPush("/");
      }

      if (errorType === "exc_user_auth_locked_out") {
        const message = deps.getUiText("app-api-user-mfa-verify-error-1");
        deps.showToastError(message);
      }

      if (errorType === "exc_user_mfa_verify_fail") {
        const message = deps.getUiText(
          "app-api-user-mfa-verify-fail-experied-1",
        );

        deps.showToastError(message);
      }

      if (
        errorType === "exc_invalid_parameters-1" &&
        errorData.error.id === "token"
      ) {
        const message = deps.getUiText(
          "app-api-user-mfa-verify-invalid-param-1",
        );

        deps.showToastError(message);
      } else {
        showErrorAPI(error, "error");
      }
    } else {
      showErrorAPI(error, "error");
    }
  }
};

export const createDefaultDependencies = (): MFAServiceDependencies => ({
  getUiText: (id) => `Text for ${id}`,
  showToastError: (message) => {
    const emitData: IToastMessage = {
      variant: ToastVariant.ERROR,
      message,
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
  },
  routerPush: (path) => window.location.assign(path),
  routerGoBack: () => window.history.back(),
  sessionStorageSetItem: (key, value) => sessionStorage.setItem(key, value),
  afterLoginActions: async () => {
    return;
  },
});
